import { utils } from "./utils";

export const config = [
    {
        link: "/inbox/",
        icon: "file-invoice-dollar",
        name: "Customer Purchase Order"
    },
    {
        icon: "file-invoice",
        name: "NON-SODE",
        children: [
            {
                link: "/non-sode/",
                name: "NON-SODE"
            },
            {
                link: "/master-budget/",
                name: "Master Budget"
            }
        ]
    },
    {
        icon: "upload",
        name: "Importers",
        children: [
            {
                link: "/cpo/upload/",
                name: "CPO Uploader"
            },
            {
                link: "/cpo-upload-importer/importer/",
                name: "CPO uploader importer"
            },
            {
                link: "cpo-item-consumption-importer",
                name: "CPO item consumption importer"
            },
            {
                link: "/qc/importer/",
                name: "QC Importer"
            },
            {
                link: "/wbs/importer",
                name: "WBS Importer"
            },
            {
                link: "/service-task-list-operation-importer",
                name: "STLO importer"
            },
            {
                link: "/good-receipt/importer",
                name: "GR importer"
            },
            {
                link: "/stp-master-data/importer",
                name: "STP master importer"
            },
            {
                link: "/activity/importer/",
                name: "Activity Importer",
                code_perm: "can_manage_activity_smp"
            }
        ]
    },
    {
        icon: "file-download",
        name: "Reports",
        children: [
            {
                link: "/cpo/report/",
                name: "CPO Reports",
                code_perm: "can_download_cpo_report"
            },
            {
                link: "/run/historic/report",
                name: "Run Historic Reports"
            },
            {
                link: "/oetdashboardreport/",
                name: "OET Dashboard Report"
            },
            {
                link: "/oet-dashboard-report-bi/",
                name: "OET Dashboard Report (BI)"
            },
            {
                link: "/oet-run-report/",
                name: "Project OET_RUN Report"
            },
            {
                link: "/cpo/cmn-report/",
                name: "CMN Report"
            },
            {
                link: "/cpo/pr-validation-report/",
                name: "PR Validation & Run ID Closure Report"
            },
            {
                link: "/ssot/cost-package-by-ssot-report/",
                name: "Cost package by SSOT item report"
            },
            {
                link: "/non-sode/dashboard-report/",
                name: "Non sode dashboard report"
            },
            {
                link: "/sode/site-vs-run/report/",
                name: "Site id vs Run id report"
            },
            {
                link: "/sode/open_run_pendency/report/",
                name: "Open run id vs Pendency report"
            },
            {
                link: "/sode/bharti-approved-oet/report/",
                name: "Bharti Approved OET Report"
            },
            {
                link: "/sode/customer-capacity-plan/report/",
                name: "Customer Capacity Plan Report",
                code_perm: "can_download_customer_capacity_plan_report"
            }
        ]
    },
    {
        link: "/activity/",
        icon: "network-wired",
        name: "Activity Management",
        code_perm: "can_manage_activity_smp"
    },
    {
        link: "/vendors/",
        icon: "address-card",
        name: "Vendor Management"
    },
    {
        link: "/costpackage/",
        icon: "donate",
        name: "Cost Package Management"
    },
    {
        link: "/voa/",
        icon: "user-cog",
        name: "VOA Management"
    },
    {
        link: "/voa-summary/",
        icon: "clipboard-list",
        name: "VOA Summary"
    },
    {
        link: "/cpo/blank-oet-received-date-importer/",
        icon: "calendar-alt",
        name: "blank OET received date importer"
    },
    {
        link: "/importers/list/",
        icon: "file-upload",
        name: "Importer log"
    },
    {
        link: "#",
        icon: "search-plus",
        name: "QC Details"
    }
];

export const filterConfigByPerm = (config, user) => {
    if (!config) return [];

    const new_config = config
        .filter(item => {
            if (item.code_perm && !utils.user_has_perm(user, item.code_perm)) {
                return false;
            }
            return true;
        })
        .map(item => {
            if (item.children && item.children.length > 0) {
                const filteredChildren = filterConfigByPerm(item.children, user);
                return { ...item, children: filteredChildren };
            }
            return item;
        })
        .filter(item => {
            if (item.children && item.children.length === 0) {
                return false;
            }
            return true;
        });

    return [...new_config];
};
